module.exports = __webpack_public_path__ + "static/media/icon-check-circle.e73c9ade.svg";